module.exports = __webpack_public_path__ + "static/media/ficcc.4f0ff63d.svg";